import { Injectable, Inject, PLATFORM_ID, NgZone } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Card {
    image: string;
    category: string;
    title: string;
    author: string;
    avatar: string;
    date: string;
    badge?: { color: string; text: string; icon: string };
}

@Injectable({ providedIn: 'root' })
export class PreloaderService {
    private cards: Card[] = [];
    private cards$ = new BehaviorSubject<Card[]>([]);
    private loading$ = new BehaviorSubject<boolean>(false);

    private offset = 0;
    private limit = 5;


    getCardsStream(): Observable<Card[]> {
        return this.cards$.asObservable();
    }

    getLoadingStream(): Observable<boolean> {
        return this.loading$.asObservable();
    }

    reset() {
        this.cards = [];
        this.cards$.next([]);
        this.offset = 0;
        this.loadMore(); // ✅ load first 5 only
    }

    loadMore() {
        if (this.loading$.value) return;
        if (this.offset >= this.allCards.length) return;

        this.loading$.next(true);

        setTimeout(() => {
            const next = this.allCards.slice(this.offset, this.offset + this.limit);
            this.cards = [...this.cards, ...next];
            this.cards$.next(this.cards);
            this.offset += this.limit;
            this.loading$.next(false);
        }, 2000);
    }
    isAllLoaded(): boolean {
        return this.offset >= this.allCards.length;
    }
    private allCards: Card[] = [
        {
            image: 'assets/img/cards/4.jpg',
            category: 'Science',
            title: 'Exploring the Adaptations and Behaviors of these Majestic Birds',
            author: 'Sophia Miller',
            avatar: 'assets/img/avatars/11.jpg',
            date: '2 hours ago',
            badge: { color: 'green', text: 'Paid', icon: 'money_dollar_circle_fill' }
        },
        {
            image: 'assets/img/cards/5.jpg',
            category: 'Technology',
            title: 'The Rise of AI in Everyday Applications',
            author: 'James Smith',
            avatar: 'assets/img/avatars/12.jpg',
            date: '3 hours ago'
        },
        {
            image: 'assets/img/cards/4.jpg',
            category: 'Health',
            title: 'Nutrition Tips for a Healthier Lifestyle',
            author: 'Emily Johnson',
            avatar: 'assets/img/avatars/13.jpg',
            date: '5 hours ago'
        },
        {
            image: 'assets/img/cards/8.jpg',
            category: 'Travel',
            title: 'Discovering Hidden Gems Around the World',
            author: 'Michael Brown',
            avatar: 'assets/img/avatars/14.jpg',
            date: '1 day ago'
        },
        {
            image: 'assets/img/cards/8.jpg',
            category: 'Sports',
            title: 'The Evolution of Football Over the Decades',
            author: 'Sarah Davis',
            avatar: 'assets/img/avatars/15.jpg',
            date: '2 days ago'
        },
        {
            image: 'assets/img/cards/4.jpg',
            category: 'Education',
            title: 'The Future of Online Learning Platforms',
            author: 'David Wilson',
            avatar: 'assets/img/avatars/16.jpg',
            date: '3 days ago'
        },
        {
            image: 'assets/img/cards/4.jpg',
            category: 'Science',
            title: 'Exploring the Adaptations and Behaviors of these Majestic Birds',
            author: 'Sophia Miller',
            avatar: 'assets/img/avatars/11.jpg',
            date: '2 hours ago',
            badge: { color: 'green', text: 'Paid', icon: 'money_dollar_circle_fill' }
        },
        {
            image: 'assets/img/cards/5.jpg',
            category: 'Technology',
            title: 'The Rise of AI in Everyday Applications',
            author: 'James Smith',
            avatar: 'assets/img/avatars/12.jpg',
            date: '3 hours ago'
        },
        {
            image: 'assets/img/cards/2.jpg',
            category: 'Health',
            title: 'Nutrition Tips for a Healthier Lifestyle',
            author: 'Emily Johnson',
            avatar: 'assets/img/avatars/13.jpg',
            date: '5 hours ago'
        },
        {
            image: 'assets/img/cards/1.jpg',
            category: 'Travel',
            title: 'Discovering Hidden Gems Around the World',
            author: 'Michael Brown',
            avatar: 'assets/img/avatars/14.jpg',
            date: '1 day ago'
        },
        {
            image: 'assets/img/cards/8.jpg',
            category: 'Sports',
            title: 'The Evolution of Football Over the Decades',
            author: 'Sarah Davis',
            avatar: 'assets/img/avatars/15.jpg',
            date: '2 days ago'
        },
        {
            image: 'assets/img/cards/4.jpg',
            category: 'Education',
            title: 'The Future of Online Learning Platforms',
            author: 'David Wilson',
            avatar: 'assets/img/avatars/16.jpg',
            date: '3 days ago'
        },
        {
            image: 'assets/img/cards/4.jpg',
            category: 'Science',
            title: 'Exploring the Adaptations and Behaviors of these Majestic Birds',
            author: 'Sophia Miller',
            avatar: 'assets/img/avatars/11.jpg',
            date: '2 hours ago',
            badge: { color: 'green', text: 'Paid', icon: 'money_dollar_circle_fill' }
        },
        {
            image: 'assets/img/cards/5.jpg',
            category: 'Technology',
            title: 'The Rise of AI in Everyday Applications',
            author: 'James Smith',
            avatar: 'assets/img/avatars/12.jpg',
            date: '3 hours ago'
        },
        {
            image: 'assets/img/cards/2.jpg',
            category: 'Health',
            title: 'Nutrition Tips for a Healthier Lifestyle',
            author: 'Emily Johnson',
            avatar: 'assets/img/avatars/13.jpg',
            date: '5 hours ago'
        },
        {
            image: 'assets/img/cards/1.jpg',
            category: 'Travel',
            title: 'Discovering Hidden Gems Around the World',
            author: 'Michael Brown',
            avatar: 'assets/img/avatars/14.jpg',
            date: '1 day ago'
        },
        {
            image: 'assets/img/cards/8.jpg',
            category: 'Sports',
            title: 'The Evolution of Football Over the Decades',
            author: 'Sarah Davis',
            avatar: 'assets/img/avatars/15.jpg',
            date: '2 days ago'
        },
        {
            image: 'assets/img/cards/4.jpg',
            category: 'Education',
            title: 'The Future of Online Learning Platforms',
            author: 'David Wilson',
            avatar: 'assets/img/avatars/16.jpg',
            date: '3 days ago'
        }
    ];
}
